<template>
<div>
    <div :class="{'has-logo':showLogo}" class="slideBarItem">
        <logo v-if="showLogo" :user-info="userInfo" :collapse="false" @userShowModal="$store.state['zsm-user'].sliderUserInfo=true" />
        <div style="display: flex;align-items: center;width: 100%;justify-content: center;position: absolute;top: 80px; padding: 23px 0;border-top: 1px solid #F5F6FA;border-bottom: 1px solid  #F5F6FA;">
            <el-button v-if="douyinPlatFormDict=='doudian'" style="width:80px;text-align: center;font-size: 12px;padding: 10px 5px;" type="primary" size="mini" @click="addCourse">同步橱窗</el-button>

            <el-button v-else style="width:80px;text-align: center;font-size: 12px;padding: 10px 5px;" type="primary" size="mini" @click="addCourse">添加课程</el-button>

            <el-button v-if="douyinPlatFormDict=='douyin'||douyinPlatFormDict=='doudian'" style="width: 80px;text-align: center;font-size: 12px;padding: 10px 5px;" type="primary" size="mini" @click="createTiktok(douyinPlatFormDict)">发布抖音</el-button>

            <el-button v-if="douyinPlatFormDict=='kuaishou'" style="width: 80px;text-align: center;font-size: 12px;padding: 10px 5px;" type="primary" size="mini" @click="createTiktok(douyinPlatFormDict)">发布快手</el-button>

            <el-button v-if="douyinPlatFormDict=='shipinhao'" style="width: 80px;text-align: center;font-size: 12px;padding: 10px 5px;" type="primary" size="mini" @click="createTiktok(douyinPlatFormDict)">发布视频号</el-button>

            <el-button v-if="douyinPlatFormDict=='xiaohongshu'" style="width: 80px;text-align: center;font-size: 12px;padding: 10px 5px;" type="primary" size="mini" @click="createTiktok(douyinPlatFormDict)">发布小红书</el-button>

        </div>
        <el-scrollbar wrap-class="scrollbar-wrapper" style="position: static">

            <el-menu :router="true" :default-active="activeMenu" :collapse="false" :background-color="variables.menuBg" :text-color="variables.menuText" :unique-opened="true" :active-text-color="variables.menuActiveText" :collapse-transition="true" mode="vertical">
                <!--<div  v-for="item of zsmWebUserPermissionDict">
          <el-menu-item :index="item.dictValue" style="padding-left: 17px!important;" @click="activeMenu=''" v-if="item.list.length==0">
            <div>
              <svg-icon v-if="activeMenu!==item.dictValue"  :icon-class="item.description" />
              <svg-icon v-else :icon-class="item.dictIcon" color="red"/>
              <span slot="title">{{item.dictLabel}}</span>
            </div>
          </el-menu-item>

          <el-submenu :id="item.cssClass" :index="item.dictValue"   v-if="item.list.length>0">
            <template slot="title">
              <div>
                <svg-icon color="#010101" :icon-class="item.dictIcon" />
                <span>{{item.dictLabel}}</span>
              </div>
            </template>

            <el-menu-item-group v-if="item.list.length>0">
              <el-menu-item :index="children.dictValue" v-for="children of item.list">{{children.dictLabel}}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </div>-->

                <el-menu-item index="/user" style="padding-left: 17px!important;" @click="activeMenu=''">
                    <div>
                        <svg-icon v-if="activeMenu!=='/user'" color="red" icon-class="antFill-pie-chart" />
                        <svg-icon v-else icon-class="pie-chart-2-line" />
                        <span slot="title">概况</span>
                    </div>
                </el-menu-item>
                <el-submenu id="some-element1" index="/shop">

                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="iconPark-application" />
                            <span>店铺管理</span>
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/shop/knowledge">知识店铺</el-menu-item>
                        <!--              <el-menu-item index="/shop/part-time">服务店铺</el-menu-item>-->
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu id="some-element2" index="/course">
                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="st-product" />
                            <span>内容管理</span>
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/course/list">课程管理</el-menu-item>
                        <el-menu-item v-if="$store.state['zsm-user'].douyinPlatFormDict=='shipinhao'" :class="activeMenu.indexOf('shipinhao')==-1?'':'is-active'" index="/shipinhao/list">视频号卖货</el-menu-item>
                        <el-menu-item v-if="$store.state['zsm-user'].douyinPlatFormDict=='xiaohongshu'" :class="activeMenu.indexOf('xiaohongshu')==-1?'':'is-active'" index="/xiaohongshu/list">小红书卖货</el-menu-item>
                        <!-- <el-menu-item v-if="$store.state['zsm-user'].platformDict=='shipinhao'" index="/weixin/article">公众号/H5挂载</el-menu-item> -->
                        <el-menu-item v-if="$store.state['zsm-user'].platformDict=='douyin'" index="/course/doudian">抖店商品</el-menu-item>
                        <el-menu-item v-if="$store.state['zsm-user'].platformDict=='kuaishou'" index="/course/tiktok">快手作品</el-menu-item>
                        <el-menu-item v-if="$store.state['zsm-user'].platformDict=='douyin'" index="/course/tiktok">抖音作品</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu index="/serve">
                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="iconPark-folder-download" />
                            <span>兼职服务</span></div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/serve/list">商业服务</el-menu-item>
                        <el-menu-item index="/serve/download-list">素材文库</el-menu-item>
                        <el-menu-item index="/serve/consult-list">付费咨询</el-menu-item>
                        <!--               <el-menu-item index="/serve/series-list">关联商品</el-menu-item> -->
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu index="/dist">
                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="iconPark-branch-one" />
                            <span>达人服务</span></div>
                    </template>

                    <el-menu-item-group>
                        <el-menu-item index="/dist/list">达人管理</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="/dist/popularize">通告管理</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="/dist/popularizelist">通告接单管理</el-menu-item>
                    </el-menu-item-group>

                    <el-menu-item-group>
                        <el-menu-item index="/dist/fee">分销订单明细</el-menu-item>
                    </el-menu-item-group>

                </el-submenu>

                <el-submenu id="some-element3" index="/statistics">
                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="semiDesign-semi-icons-histogram" />
                            <span>收益管理</span>
                        </div>
                    </template>
                    <el-menu-item-group title="/statistics">
                        <!--              <el-menu-item index="/statistics/funds">资金收益</el-menu-item>-->
                        <!--              <el-menu-item index="/statistics/funds">资金统计</el-menu-item>-->

                        <el-menu-item index="/fund/withdraw">资金收益</el-menu-item>
                        <!--              <el-menu-item index="/overview">数据管理</el-menu-item>-->
                        <el-menu-item index="/statistics/order">订单统计</el-menu-item>
                        <el-menu-item index="/statistics/consult-order">咨询订单</el-menu-item>
                        <el-menu-item index="/order/deliver">发货订单</el-menu-item>

                        <el-menu-item index="/complaints/index">投诉数据</el-menu-item>

                        <!--              <el-menu-item index="/statistics/refund">退款订单</el-menu-item>-->

                        <el-menu-item index="/order/aftersale">售后工作台</el-menu-item>
                        <!--            <el-menu-item index="/statistics/doudian-order">第三方平台订单</el-menu-item>-->

                    </el-menu-item-group>
                </el-submenu>

                <el-submenu index="/material">
                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="iconPark-folder-close" />
                            <span>素材库</span>
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/material/video">视频</el-menu-item>
                        <el-menu-item index="/material/audio">音频</el-menu-item>
                        <el-menu-item index="/material/image">图片</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <!-- <el-submenu index="11">
            <template slot="title">
              <div>
                <svg-icon color="#010101" icon-class="iconPark-folder-close" />
                <span>题库中心</span>
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/exam/question">题目管理</el-menu-item>
              <el-menu-item index="/exam/batch">批量导入</el-menu-item>
              <el-menu-item index="/exam/index">考试管理</el-menu-item>
            </el-menu-item-group>
          </el-submenu> -->

                <el-submenu v-if="$store.state['zsm-user'].platformDict=='douyin'" id="some-elemen10" index="/interaction">
                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="kequn" />
                            <span>私域管理</span>
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item v-if="$store.state['zsm-user'].platformDict=='douyin'" index="/interaction/privatemessage/list">抖音粉丝群</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu id="some-elemen4" index="/market">
                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="coupon" />
                            <span>营销中心</span>
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/market/coupon">优惠券</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="/market/flash-sale">限时抢购</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="/market/givetmeal">买赠套餐</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="/market/live">挂载集合页</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="/sms">短信通知</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="/market/object">附赠实物</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu id="some-elemen5" index="/auth">
                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="renzheng" />
                            <span>认证管理</span>
                        </div>
                    </template>
                    <el-menu-item-group v-if="$store.state['zsm-user'].platformDict=='douyin'">
                        <el-menu-item index="/mountscope">挂载能力</el-menu-item>
                    </el-menu-item-group>

                    <!-- <el-menu-item-group >
             <el-menu-item index="/account/certification">资质管理</el-menu-item>
           </el-menu-item-group> -->
                    <el-menu-item-group>
                        <el-menu-item  index="/certification/home">资质管理</el-menu-item>
                    </el-menu-item-group>

                    <el-menu-item-group>
                        <el-menu-item index="/account/copyright">版权管理</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu index="/help">
                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="bangzhu" />
                            <span>帮助中心</span>
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/tutorial/index">帮助中心</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="/question">热门课程</el-menu-item>
                    </el-menu-item-group>
                    <!--            <el-menu-item-group>-->
                    <!--              <el-menu-item index="/feedback">反馈管理</el-menu-item>-->
                    <!--            </el-menu-item-group>-->

                    <!--
            <el-menu-item-group>
              <el-menu-item index="/feedback">反馈中心</el-menu-item>
            </el-menu-item-group>-->
                </el-submenu>

                <el-submenu id="some-elemen10" index="/account">
                    <template slot="title">
                        <div>
                            <svg-icon color="#010101" icon-class="set" />
                            <span>设置</span>
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/account/setting">账号设置</el-menu-item>
                    </el-menu-item-group>

                    <el-menu-item-group>
                        <el-menu-item index="/account/ksaccount">快手账号</el-menu-item>
                    </el-menu-item-group>

                    <el-menu-item-group>
                        <el-menu-item index="/account/dyaccount">抖音账号</el-menu-item>
                    </el-menu-item-group>

                    <el-menu-item-group>
                        <el-menu-item index="/account/wxaccount">微信账号</el-menu-item>
                    </el-menu-item-group>
                    <!-- <el-menu-item-group>
              <el-menu-item index="/account/employee/list">人员设置</el-menu-item>
            </el-menu-item-group>-->

                </el-submenu>

                <el-menu-item v-if="sliderbarAlipayStatus==1" :class="activeMenu.indexOf('merchandise')==-1?'':'is-active'" index="/merchandise" style="padding-left: 17px!important;" @click="activeMenu=''">
                    <div>
                        <svg-icon v-if="activeMenu.indexOf('merchandise')==-1" icon-class="yingyong" />
                        <svg-icon v-else icon-class="yingyongRed" />
                        <span slot="title" :style="{'color':activeMenu.indexOf('merchandise')==-1?'':'#f00'}">应用</span>
                    </div>
                </el-menu-item>

            </el-menu>

            <!-- <el-menu
          default-active="activeMenu"
          :collapse="false"
          :background-color="variables.menuBg"
          :text-color="variables.menuText"
          :unique-opened="false"
          :active-text-color="variables.menuActiveText"
          :collapse-transition="false"
          mode="vertical"
        >
          <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />

        </el-menu> -->

            <!-- <div class="course_tutorial	flex pointer" @click="preViewExamples()">
          <i class="el-icon-question" />
          <p>教程</p>
        </div> -->
        </el-scrollbar>

    </div>

    <!-- <el-dialog class="sliderUserInfo" title="" :modal="false" :visible.sync="sliderUserInfo" width="360px">
      <div class="userInfo">
        <div class="userInfoT flex">
          <img v-if="userInfo.avatar&&userInfo.avatar!=''" :src="userInfo.avatar" alt="">
          <img v-else src="../../../static/daoshi.png" alt="">

          <div>
            <div>{{userInfo.name}}</div>
            <span>{{userInfo.mobile}}</span>
          </div>
        </div>

        <div class="userInfoB">
          <div>
            <div>联系人：</div>
            <span>{{userInfo.realName}}</span>
          </div>
          <div>
            <div>联系电话：</div>
            <span>{{userInfo.mobile}}</span>
          </div>

        </div>
      </div>

      <div slot="footer">
        <div class="loginout pointer" @click="loginOut">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAKlBMVEVHcEwVFyMUGCAUFyMWGCIQECAVFyIVFyIUFiIWGCMVGCMVFyITFSMWGCMCCGxmAAAADXRSTlMA7yC53xCWcEuAX88w3Ch3MgAAAXtJREFUOMullLtKA0EUhtcNaxKNIDEXLBY2WNrYSyo7YWF9gICxshEM2Apb2QX0AQQfQBt7wdrKJZqL4X8Xz8yZa9xC9DQze77MmXP5J0HwH7vrlPvXgdtSsAZsl4It4P23oBqfWbDXsjfdY2JBHwvtrwNINIhgk7umfaZBSB8z9ocx/FAoEgk26TfPFuzT54EET8BHYkGYAnMJaNN06+gBS7HW6OilC6rkyGmtUCS/8pQvGQBfPqD027SMdVMNOOHbL4BTH9BgplzQgw82uOAX4NUHDU4nlo1yAfWxoIWyXh0tuwyo6yyUy4QKhruBGyrVlxtrcLNMusZUuqZAV3lTbkn7h/Lm3JmZD2hyn27bjam2m0EZ+alBiWY1XdDTIcZKDMqEGHhyFSUfZVY+QnD2iDigBCcl2tVgZCUqRY1j7t8VHFHTMyDrPGbR21DszDPgI9acJzpy/V2nprBv/ZPEG0Gq/cvcb1xNndnJVx9zdHMYF0fn2d//cb4BRjwkEHRO53oAAAAASUVORK5CYII="
            alt="">
          退出登录
        </div>
      </div>

    </el-dialog> -->

    <!-- <questionInfo></questionInfo> -->
</div>
</template>

<script>
import driverStep from '@/utils/driver'

// import questionInfo from "../question/index.vue"
import {
    mapGetters
} from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

import {
    saveLocalStorage,
    getLocalStorage,
    removeLocalStorage
} from '@/utils/auth.js'
export default {
    components: {
        SidebarItem,
        Logo
    },
    data() {
        return {
            sliderbarAlipayStatus: 0, // 应用是否显示
            zsmWebUserPermissionDict: [], // 权限列表
            driverStep2: [], // 指引
            // userInfo: '', //用户信息
            sliderUserInfo: false, // 用户信息
            activeIndex: -1 // 默认选中的下标
        }
    },
    // watch: {
    //   routerNow() {
    //     this.activeIndex = -1
    //     this.permission_routes.map((item, index) => {
    //       if (item.name == this.$route.name) {
    //         this.activeIndex = index
    //       }
    //     })
    //   }
    // },
    computed: {
        douyinPlatFormDict() {
            return this.$store.state['zsm-user'].douyinPlatFormDict
        },
        userInfo() {
            if (this.$store.state['zsm-user'].userInfo) {
                return JSON.parse(JSON.parse(this.$store.state['zsm-user'].userInfo))
            } else {
                return JSON.parse(JSON.parse(this.$store.state['zsm-user'].userInfo))
            }
        },
        // routerNow() {
        //   return this.$router
        // },
        // ,'userInfo'
        ...mapGetters([
            // 'permission_routes',
            'sidebar', 'mobile'
        ]),
        permission_routes() {
            var routes = []
            routes = this.$router.options.routes.filter((item, index) => {
                if (item.hidden !== true) {
                    return item
                }
            })

            // return this.$store.state.permission.routes
            return routes
        },
        activeMenu() {
            const route = this.$route
            const {
                meta,
                path
            } = route
            // if set path, the sidebar will highlight the path you set
            if (meta.activeMenu) {
                return meta.activeMenu
            }
            return path
        },
        showLogo() {
            return this.$store.state.settings.sidebarLogo
        },
        variables() {
            return variables
        },
        isCollapse() {
            // return !this.sidebar.opened
        }
    },
    mounted() {
        this.activeIndex = -1
        this.permission_routes.map((item, index) => { // 当前导航地址
            if (item.name == this.$route.name) {
                this.activeIndex = index
            }
        })
        if (!getLocalStorage('zsm_guide')) {
            this.driverStep2 = driverStep // 新手指引
            this.getSettingDict(true)
        } else {
            this.getSettingDict(false)
        }
        this.$store.dispatch('zsm-dict/settingConfig', 'zsm_sliderbar_alipay_status').then((info) => {
            this.sliderbarAlipayStatus = info
        })
    },

    methods: {

        // 获取字典内容
        getSettingDict(guide) {
            this.$store.dispatch('zsm-dict/settingDict', 'zsm_web_user_permission_dict').then(info => { // 知视猫--前端默认权限内容
                saveLocalStorage('zsm_web_user_permission_dict', info)
                this.getZsmWebUserPermissionDict(info)
            })

            if (guide == true) {
                this.$store.dispatch('zsm-dict/settingDict', 'zsm_web_guide_list').then(info => {
                    this.getZsmWebGuideList(info)
                })
            }
        },

        // 获取权限列表
        getZsmWebUserPermissionDict(info) {
            const zsmWebUserPermissionDict = []
            const zsmWebUserPermissionTwoDict = []
            info.map((item, index) => { // 一级菜单
                item.checkedList = [] // 选中的内容列表
                item.checked = false // 选中状态
                item.isIndeterminate = false // 监听是否全选
                if (item.treeLevel == 0) {
                    zsmWebUserPermissionDict.push(item)
                } else { // 二级菜单
                    zsmWebUserPermissionTwoDict.push(item)
                }
            })
            zsmWebUserPermissionDict.map((item, index) => { // 合并数据
                item.list = []
                zsmWebUserPermissionTwoDict.map((twoItem) => {
                    if (item.id == twoItem.parentCode) {
                        item.list.push(twoItem)
                    }
                })
            })
            this.zsmWebUserPermissionDict = zsmWebUserPermissionDict
        },
        getZsmWebGuideList(info) { // 指引
            info.map((guideItem) => {
                this.driverStep2.map((item, index) => {
                    if (item.popover.className == guideItem.cssClass) { // 类名一致的话
                        item.popover.className = guideItem.dictValue
                        item.popover.title = guideItem.description.replace(new RegExp('＜', 'g'), '<').replace(new RegExp('＞', 'g'), '>').replace(new RegExp('＂', 'g'), '"')
                        item.popover.description = guideItem.remarks.replace(new RegExp('＜', 'g'), '<').replace(new RegExp('＞', 'g'), '>').replace(new RegExp('＂', 'g'), '"')
                        item.popover.position = guideItem.cssClass
                    }
                })
            })
            this.$driver.defineSteps(this.driverStep2)
            this.$driver.start()
        },

        // 方法
        start() {
            this.$nextTick(() => {
                this.$driver.defineSteps(this.driverStep2)
                this.$driver.start()
            })
        },
        // 退出
        loginOut() {
            const that = this
            this.$confirm('退出知视猫创作者管理后台?', '提示', {
                confirmButtonText: '立即退出',
                cancelButtonText: '暂不退出',
                type: 'warning'
            }).then(() => {
                that.$store.dispatch('zsm-user/accountLogout', that.userInfo.mobile).then((res) => {
                    that.$router.replace('/login')
                })
            }).catch(() => {

            })
        },
        // 创建课程/同步橱窗
        addCourse() {
            if (this.douyinPlatFormDict == 'doudian') { // 同步橱窗
                this.$router.push('/merchandise/index')
            } else if (this.douyinPlatFormDict == 'xiaohongshu') { // 小红书
                this.$router.push('/xiaohongshu/add')
            } else { // 创建课程
                this.$router.push('/course/album')
            }
        },
        // 创建抖音
        createTiktok(douyinPlatFormDict) {
            if (this.douyinPlatFormDict == 'douyin') { // 抖音端发布抖音页
                this.$router.push('/tiktok')
            } else if (this.douyinPlatFormDict == 'kuaishou') { // 快手端跳转到飞书教程
                window.open('https://zhishimao.feishu.cn/docx/PuXbdw86KoJnR6xp1CYcmMCNnRh', '_black')
            } else if (this.douyinPlatFormDict == 'doudian') { // 抖店端跳转到飞书教程
                window.open('https://zhishimao.feishu.cn/docx/OaujdXJmGofCaAxGm9xceyYrnqf', '_black')
            } else if (this.douyinPlatFormDict == 'shipinhao') { // 视频号端跳转到飞书教程
                window.open('https://zhishimao.feishu.cn/docx/RiVydDcgCoZiJ7x5Bt1cpKvsnXd', '_black')
            } else if (this.douyinPlatFormDict == 'xiaohongshu') { //小红书端跳转到飞书教程

            }
        },
        preViewExamples() {
            this.$store.dispatch('zsm-dict/settingConfig', 'zsm_upload_pc_tutorial').then((info) => {
                this.$store.state['zsm-dict'].examplesImage = info
                this.$store.state['zsm-dict'].examplesModal = true
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variable-color.scss";

.is-active::v-deep {
    @include color_primary(bg_color_primary); //边框

    path {
        @include fill_color_primary(bg_color_primary); //边框
        @include stroke_color_primary(bg_color_primary); //边框
    }

    span {
        @include color_primary(bg_color_primary_dark); //边框
    }
}

.sliderUserInfo::v-deep {

    .el-dialog__footer {
        padding: 0;
        display: flex;
        align-items: center;
        height: 40px;
        background: rgba(22, 24, 35, .02) !important;
    }

    .loginout {
        color: rgba(22, 24, 35, .7);
        text-align: left;
        font-size: 14px;
        width: 200px;
        margin-left: 30px;
        position: relative;
        cursor: pointer;
        height: 40px;
        display: flex;
        align-items: center;
        line-height: 40px;

        img {
            margin-right: 6px;
            width: 16px;
            height: 16px;
        }

        /*  &::before {
        content: "";
        position: absolute;
        background: url();
        background-size: 100% 100%;
        width: 16px;
        height: 16px;
        top: 52%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        left: -24px;
      } */
    }

    .el-dialog {
        margin-left: 30px;
        margin-top: 110px !important;
    }

    .el-dialog__body {
        padding: 24px 32px;
        padding-top: 0;
    }

    .userInfoB {
        &>div {
            padding-top: 14px;
        }

        div {
            font-family: PingFang SC;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            color: #161823;
            margin-bottom: 8px;
        }

        span {
            font-family: PingFang SC;
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            color: #161823;
        }
    }

    .userInfo {
        .userInfoT {
            display: flex;
            width: 100%;
            padding-bottom: 16px;
            border-bottom: 1px solid rgba(22, 24, 35, .06);

            img {
                width: 48px;
                height: 48px;
                margin-right: 8px;
                display: -webkit-box;
                display: flex;
                -webkit-box-align: center;
                align-items: center;
                border-radius: 50%;
            }

            &>div {
                div {
                    font-family: PingFang SC;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 24px;
                    width: 100%;
                    color: #161823;
                    margin-bottom: 4px;
                    position: relative;

                }

                span {
                    font-family: PingFang SC;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 17px;
                    color: rgba(22, 24, 35, .5);
                    margin-bottom: 10px;
                }
            }
        }
    }

}

.el-menu::v-deep {

    &>li {
        margin-bottom: 5px;

        i {
            font-size: 16px;
            font-weight: bold;
            position: absolute;
            right: 30px;
        }
    }

    .is-opened {
        .el-submenu__title {
            div {
                border-radius: 8px 8px 0 0;
                background-color: #F5F6FA !important;
            }

        }

        ul {
            ul {
                padding-left: 45px;
                background-color: #F5F6FA !important;
                border-radius: 0 0 8px 8px;
                margin-left: 17px;
                width: 163px !important;

                li {
                    padding: 0 !important;
                    // padding-left:30px!important;
                    width: 113px !important;

                    &::after {
                        display: none !important;

                    }

                    background-color: #F5F6FA !important;
                }
            }
        }

    }

    .is-active {
        i {
            @include color_primary($color-primary-red);

            /*color: #fe2c55;*/
        }

        &>div {

            &::after {
                content: "";
                display: block;
                width: 4px;
                height: 24px;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                @include bg_color_primary(bg_color_primary_dark); //边框

                position: absolute;
                left: 0px;
                top: 50%;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
            }
        }

        ul {
            ul {
                padding-left: 45px;
                background-color: #F5F6FA !important;
                border-radius: 0 0 8px 8px;
                margin-left: 17px;
                width: 163px !important;

                li {
                    padding: 0 !important;
                    // padding-left:30px!important;
                    width: 110px !important;

                    &::after {
                        display: none !important;

                    }

                    background-color: #F5F6FA !important;
                }
            }
        }

        .el-submenu__title {
            div {
                border-radius: 8px 8px 0 0;
                background-color: #F5F6FA !important;
            }

            i {
                font-size: 16px;
                font-weight: bold;
            }
        }

    }

}

.slideBarItem::v-deep {

    /*position: relative;*/
    background-color: '' !important;
    // top: 48px;
    // padding-top: 190px;
    padding-top: 185px;
    margin-bottom: 100px;
    overflow-y: auto;
    // height: 100vh;
    height: calc(100vh - 70px);

    .el-menu-item {
        min-width: 100px !important;
    }

    svg {
        font-size: 20px;
        color: #010101;
    }

    i {
        font-size: 16px;
        font-weight: bold;
    }

    .el-submenu__title {
        display: flex;
        align-items: center;
        padding-left: 17px !important;
        background-color: '' !important;

        &>div {
            align-items: center;
            display: flex;
            padding: 0 10px;
            width: 100%;
            border-radius: 8px;
            height: 56px;
            line-height: 56px;

            &:hover {
                background-color: #F5F6FA;
            }
        }

        // padding-left: 30px!important;
    }

    .sidebar-logo-container {
        position: absolute;
        height: 80px;
        top: 0px;
        width: 100%;
    }

    &::-webkit-scrollbar {
        width: 0px;
        height: 6px;
        background-color: rgba(240, 240, 240, 1);
    }

    .el-menu-item {
        font-weight: normal !important;
        align-items: center;
        display: flex;

        &:hover {
            background-color: transparent !important;
        }

        &>div {
            align-items: center;
            display: flex;
            padding: 0 10px;
            width: 100%;
            border-radius: 8px;
        }

        // margin: 0 10px;
        svg {
            font-size: 20px;
            color: #010101;
            fill: currentColor;
            margin-top: -1px;
        }

        &.is-active {
            &>div {
                width: 100%;
                background-color: rgba(245, 246, 250, 100) !important;
            }

            position: relative;
            // background-color: rgba(245, 246, 250, 100) !important;
            box-sizing: border-box;
            border-radius: 2px;

            svg {
                margin-top: -1px;
                fill: currentColor;
                @include color_primary(bg_color_primary_dark); //边框

                /*color: rgba(255, 77, 109, 100);*/
            }

            // border-left: 5px solid rgba(255, 77, 109, 100);
            &::after {
                content: "";
                display: block;
                width: 4px;
                height: 24px;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                /*background-color: #fe2c55;*/
                @include bg_color_primary(bg_color_primary_dark); //边框

                position: absolute;
                left: 0px;
                top: 50%;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
            }
        }
    }

    .el-menu-item-group__title {
        display: none;
    }

    .el-menu-item {
        padding-left: 62px !important;
        font-weight: bolder;
        height: 56px;

        &.is-active {
            @include color_primary(bg_color_primary_dark); //边框

            svg,
            path {
                @include fill_color_primary(bg_color_primary_dark); //边框
            }
        }

        &:hover {
            /*color: #fe2c55 !important;*/
            @include color_primary(bg_color_primary_dark); //边框

        }
    }

    .course_tutorial {
        align-items: center;
        font-size: 14px;
        top: 350px;
        height: 30px;
        left: 20px;
        color: #fff;
        position: fixed;
        z-index: 999;

        p {
            margin: 0;
            padding: 0;
            line-height: 1;
        }

        i {
            margin-right: 10px;
            color: #F7EF4C;
            font-size: 22px;
        }
    }
}
</style>
